module.exports = __webpack_public_path__ + "img/CIMB.5e1feacd.png";